import React from 'react';

import Icon from './Icon';
import { IconProps } from './types';

const AddIcon = (props: IconProps) => <Icon {...props} src={'/icons/add-blue.svg'} />;

export default AddIcon;
